export default __webpack_public_path__ + "static/media/lockani2.89dbd7f5.gif";